import React, { useEffect, useState } from 'react';
import { TrendingUpIcon, UsersIcon, TargetIcon, AwardIcon, ShieldIcon, HeartHandshakeIcon, BrainCircuitIcon, LineChartIcon } from 'lucide-react';
const events = [{
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p3nkmpNmAnqX6WoDyevdxz/Members_in_Coronado_CA_for_annual_in_person_meeting.jpg',
  title: 'Annual Meetups',
  description: 'Connect with fellow members at our annual in-person meetings, where we share strategies, celebrate successes, and strengthen our community bonds.'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DYugMs4URMkT3NJaiLSEx/Community_Service_Event.png',
  title: 'Community Service',
  description: 'Give back to the community through organized service events, supporting military families and veterans through organizations like STEP.'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ug9p4nzCtBqnDV2s6m57ZP/Spooky_Meeting.jpg',
  title: 'Virtual Socials',
  description: 'Join our themed virtual meetups where members can connect, network, and have fun while building lasting relationships across distances.'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8wWdVjRCD9SdVxRAhcMMBU/Eric_Gardner_and_Bobby_Bray_in_Ireland_-_August_2023.jpg',
  title: 'Networking Events',
  description: 'Build lasting relationships with fellow investors through regular social gatherings and networking opportunities.'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/349PNkeLcbGoxEBgNjso5M/Kurt-Rommel-Tucker-Kimbrough-Greg-Namrow-and-Rick-Sidley.jpg',
  title: 'Golf Tournament',
  description: 'Annual Support The Enlisted Project (STEP) Golf Tournament brings together members for a day of networking, strategy, and really bad golf.'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7mKqxFhCwEXb3ZG1zUDEQ9/c25203037bce369c6557b0975c6ea2d8b3d218c6-1.jpg',
  title: 'Member Gatherings',
  description: 'Enjoy casual meetups and social gatherings where members connect, share experiences, and build meaningful relationships in relaxed settings.'
}];
const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % events.length);
    }, 5000); // Rotate every 5 seconds
    return () => clearInterval(timer);
  }, []);
  const goToNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % events.length);
  };
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + events.length) % events.length);
  };
  return <div className="relative max-w-3xl mx-auto" data-id="element-207">
      <div className="bg-gray-900 rounded-lg overflow-hidden" data-id="element-208">
        <div className="relative h-96" data-id="element-209">
          <img src={events[currentIndex].image} alt={events[currentIndex].title} className="w-full h-full object-cover transition-opacity duration-500" data-id="element-210" />
          <button onClick={goToPrevious} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full" data-id="element-211">
            ←
          </button>
          <button onClick={goToNext} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-2 rounded-full" data-id="element-212">
            →
          </button>
        </div>
        <div className="p-6" data-id="element-213">
          <h3 className="text-xl font-bold mb-2" data-id="element-214">
            {events[currentIndex].title}
          </h3>
          <p className="text-gray-300" data-id="element-215">{events[currentIndex].description}</p>
        </div>
      </div>
      <div className="flex justify-center mt-4 space-x-2" data-id="element-216">
        {events.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full ${index === currentIndex ? 'bg-[#4a7c59]' : 'bg-gray-600'}`} data-id="element-217" />)}
      </div>
    </div>;
};
export function BenefitsPage() {
  return <div className="bg-black" data-id="element-218">
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-219">
        <div className="max-w-5xl mx-auto text-center" data-id="element-220">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" data-id="element-221">
            Member <span className="text-[#4a7c59]" data-id="element-222">Benefits</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-223">
            Access exclusive resources, expert guidance, and a supportive
            community of service-oriented professionals committed to achieving
            financial independence.
          </p>
        </div>
      </section>
      {/* Core Benefits Section */}

      {/* Additional Benefits Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-224">
        <div className="max-w-6xl mx-auto" data-id="element-225">
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center" data-id="element-226">
            Exclusive Member Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-227">
            <div className="flex items-start bg-gray-900 p-6 rounded-lg border border-gray-800" data-id="element-228">
              <div className="mr-4 mt-1" data-id="element-229">
                <ShieldIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-230" />
              </div>
              <div data-id="element-231">
                <h3 className="text-xl font-bold mb-2" data-id="element-232">
                  Vetted Investment Opportunities
                </h3>
                <p className="text-gray-300" data-id="element-233">
                  Access carefully screened investment opportunities
                  specifically selected for our service-oriented community.
                </p>
              </div>
            </div>
            <div className="flex items-start bg-gray-900 p-6 rounded-lg border border-gray-800" data-id="element-234">
              <div className="mr-4 mt-1" data-id="element-235">
                <HeartHandshakeIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <h3 className="text-xl font-bold mb-2" data-id="element-238">Mentor Matching</h3>
                <p className="text-gray-300" data-id="element-239">
                  Get paired with experienced investors who understand your
                  unique background and goals as a service professional.
                </p>
              </div>
            </div>
            <div className="flex items-start bg-gray-900 p-6 rounded-lg border border-gray-800" data-id="element-240">
              <div className="mr-4 mt-1" data-id="element-241">
                <BrainCircuitIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-242" />
              </div>
              <div data-id="element-243">
                <h3 className="text-xl font-bold mb-2" data-id="element-244">Expert Training</h3>
                <p className="text-gray-300" data-id="element-245">
                  Regular workshops and training sessions focused on proven
                  investment strategies and wealth-building techniques.
                </p>
              </div>
            </div>
            <div className="flex items-start bg-gray-900 p-6 rounded-lg border border-gray-800" data-id="element-246">
              <div className="mr-4 mt-1" data-id="element-247">
                <LineChartIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-248" />
              </div>
              <div data-id="element-249">
                <h3 className="text-xl font-bold mb-2" data-id="element-250">Performance Tracking</h3>
                <p className="text-gray-300" data-id="element-251">
                  Access to tools and systems for tracking your investment
                  performance and measuring progress toward your goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Community Events Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-252">
        <div className="max-w-6xl mx-auto" data-id="element-253">
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center" data-id="element-254">
            Community Events
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-center mb-12" data-id="element-255">
            Join our active community of investors who connect both
            professionally and socially through various events throughout the
            year.
          </p>
          <ImageCarousel data-id="element-256" />
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-257">
        <div className="max-w-6xl mx-auto" data-id="element-258">
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center" data-id="element-259">
            Member Testimonials
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-center mb-12" data-id="element-260">
            Hear from our community members about their experiences and success
            stories with Tactical Investor Mastermind.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-261">
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-262">
              <div className="flex flex-col h-full" data-id="element-263">
                <blockquote className="flex-grow" data-id="element-264">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-265">
                    "The Mastermind has provided me with insights and
                    perspective. Case studies have also helped me approach my
                    problems and obstacles differently."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-266">
                  <p className="text-white font-semibold" data-id="element-267">Sean Sullivan</p>
                  <p className="text-[#4a7c59]" data-id="element-268">Active Duty Marine Officer</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-269">
              <div className="flex flex-col h-full" data-id="element-270">
                <blockquote className="flex-grow" data-id="element-271">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-272">
                    "This group has provided me with valuable insight to make
                    more informed decisions regarding my family's financial
                    freedom goals."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-273">
                  <p className="text-white font-semibold" data-id="element-274">Rick Bernier</p>
                  <p className="text-[#4a7c59]" data-id="element-275">Marine Corps Officer (Ret.)</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-276">
              <div className="flex flex-col h-full" data-id="element-277">
                <blockquote className="flex-grow" data-id="element-278">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-279">
                    "...the Mastermind has motivated me and given me the courage
                    and the contacts to start my Real Estate business in a
                    pretty aggressive way."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-280">
                  <p className="text-white font-semibold" data-id="element-281">Ed Lynch</p>
                  <p className="text-[#4a7c59]" data-id="element-282">Army LtCol (Ret.)</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-283">
              <div className="flex flex-col h-full" data-id="element-284">
                <blockquote className="flex-grow" data-id="element-285">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-286">
                    "If I pose a problem to our members, I get multiple
                    suggestions with points of contact to help me execute."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-287">
                  <p className="text-white font-semibold" data-id="element-288">Shane Finlay</p>
                  <p className="text-[#4a7c59]" data-id="element-289">USMA Graduate | Army Officer</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-290">
              <div className="flex flex-col h-full" data-id="element-291">
                <blockquote className="flex-grow" data-id="element-292">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-293">
                    "This group has allowed me to invest in a diverse portfolio
                    of real estate assets: duplexes, syndications, funds, and
                    self-directing a Solo 401K -- all while improving my estate
                    plan."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-294">
                  <p className="text-white font-semibold" data-id="element-295">Gary Slyman</p>
                  <p className="text-[#4a7c59]" data-id="element-296">Marine Corps Colonel (Ret.)</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-297">
              <div className="flex flex-col h-full" data-id="element-298">
                <blockquote className="flex-grow" data-id="element-299">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-300">
                    "Joining this group was one of the most meaningful steps to
                    date in my life to achieve my dreams..I am not there yet,
                    but I am much further down the path thanks to the focus,
                    camaraderie and opportunities offered by the Tactical
                    Investor Mastermind."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-301">
                  <p className="text-white font-semibold" data-id="element-302">Tony Briggs</p>
                  <p className="text-[#4a7c59]" data-id="element-303">
                    USMA Graduate | Army Colonel (Ret.)
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-304">
              <div className="flex flex-col h-full" data-id="element-305">
                <blockquote className="flex-grow" data-id="element-306">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-307">
                    "I was inspired to join this group years ago to share
                    lessons and learn from other people smarter than me. And
                    Greg is really cool."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-308">
                  <p className="text-white font-semibold" data-id="element-309">Bob Haines</p>
                  <p className="text-[#4a7c59]" data-id="element-310">
                    USAFA Graduate | Air Force Officer (Ret.)
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-311">
              <div className="flex flex-col h-full" data-id="element-312">
                <blockquote className="flex-grow" data-id="element-313">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-314">
                    "The Mastermind has kept me committed to Real Estate and has
                    helped me stay on my journey."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-315">
                  <p className="text-white font-semibold" data-id="element-316">Bobby Bray</p>
                  <p className="text-[#4a7c59]" data-id="element-317">
                    USNA Graduate | Naval Officer
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-318">
              <div className="flex flex-col h-full" data-id="element-319">
                <blockquote className="flex-grow" data-id="element-320">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-321">
                    "I have learned through absorption by simply spending a lot
                    of time in groups that have aligned their goals with
                    myself..the group is positively changing my life."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-322">
                  <p className="text-white font-semibold" data-id="element-323">Tucker Kimbrough</p>
                  <p className="text-[#4a7c59]" data-id="element-324">
                    Active Duty Marine Corps Officer
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-325">
              <div className="flex flex-col h-full" data-id="element-326">
                <blockquote className="flex-grow" data-id="element-327">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-328">
                    "It's always motivating to see other successful real estate
                    investors."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-329">
                  <p className="text-white font-semibold" data-id="element-330">Jason Stoneman</p>
                  <p className="text-[#4a7c59]" data-id="element-331">USMA Graduate | Army Officer</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-332">
              <div className="flex flex-col h-full" data-id="element-333">
                <blockquote className="flex-grow" data-id="element-334">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-335">
                    "This Mastermind has been the sole catalyst for me to
                    achieve my financial freedom goals."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-336">
                  <p className="text-white font-semibold" data-id="element-337">Eric Gardner</p>
                  <p className="text-[#4a7c59]" data-id="element-338">
                    USNA Graduate | Navy Squadron CMDR (Ret.)
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-339">
              <div className="flex flex-col h-full" data-id="element-340">
                <blockquote className="flex-grow" data-id="element-341">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-342">
                    "This Mastermind has provided me with valuable information
                    and networks of people to work with!"
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-343">
                  <p className="text-white font-semibold" data-id="element-344">Steve Resch</p>
                  <p className="text-[#4a7c59]" data-id="element-345">USMA Graduate | Army Officer</p>
                </div>
              </div>
            </div>
            <div className="bg-black p-8 rounded-lg border border-gray-800" data-id="element-346">
              <div className="flex flex-col h-full" data-id="element-347">
                <blockquote className="flex-grow" data-id="element-348">
                  <p className="text-lg text-gray-300 italic mb-6" data-id="element-349">
                    "The group has helped me build relationships with
                    like-minded individuals and professionals."
                  </p>
                </blockquote>
                <div className="mt-4" data-id="element-350">
                  <p className="text-white font-semibold" data-id="element-351">Sean Reaver</p>
                  <p className="text-[#4a7c59]" data-id="element-352">
                    USNA Graduate | Marine Corps Officer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#4a7c59]" data-id="element-353">
        <div className="max-w-4xl mx-auto text-center" data-id="element-354">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-355">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl mb-10" data-id="element-356">
            Join our community of service-oriented professionals and accelerate
            your path to financial independence.
          </p>
          <a href="https://forms.gle/G6C1Q8Ypo6M7rVcA9" target="_blank" rel="noopener noreferrer" className="bg-white text-black hover:bg-gray-200 font-bold py-3 px-8 rounded-md text-lg inline-block" data-id="element-357">
            Apply Now
          </a>
        </div>
      </section>
    </div>;
}